<template>
  <div class="position-relative my-4">
    <v-btn-group variant="outlined">
      <v-btn
        variant="outlined"
        append-icon="mdi-format-color-fill"
        size="small"
        @click="showColorPicker = true"
      >
        {{ props.field.properties.title ?? 'Farbe' }}
      </v-btn>
      <v-btn
        :style="{ 'background-color': model }"
        class="button"
        size="small"
        :icon="!model ? 'mdi-cancel' : ''"
        @click="showColorPicker = true"
      />
      <v-btn
        v-show="props.field.required === false"
        v-tooltip:bottom="$t('components.common.remove')"
        icon="mdi-close"
        class="button"
        size="small"
        @click="clear"
      />
    </v-btn-group>
    <Compact
      v-show="showColorPicker"
      class="position-absolute top-0 elevation-12 vc-compact"
      :model-value="model ?? '#FFFFFF'"
      @update:model-value="onInput"
    />
  </div>
</template>

<script setup lang="ts">
import { Compact } from '@lk77/vue3-color'
import { ref } from 'vue'

import { FormField } from '@/components/common/forms/formBuilderHelper'

const props = defineProps<{
  field: FormField
}>()
const emit = defineEmits(['update', 'clear'])
const model = defineModel<string>()

const showColorPicker = ref(false)

function onInput(value) {
  model.value = value.hex
  showColorPicker.value = false
  emit('update')
}

function clear() {
  model.value = undefined
  emit('clear')
}
</script>

<style lang="scss">
.vc-compact {
  width: 247px !important;
  z-index: 1000;
}
</style>
